import axios from "axios";
import server from 'util/Server';


const host  = `${server.host}${server.puertoMsClientesCredito}`

const headersRequest =  { Authorization: server.obtenerToken() } 

export const getClientsByOrganizations = async (organization_id:number) =>{
    return axios.get(host+'/api/own_customers/customer/get',{headers:headersRequest,params:{
        organizacionId:organization_id
    }})
}

export const getCostsCenter = async ()=>{
    return axios.get(host+'/api/own_customers/cost_center',{headers:headersRequest})
}

export const getControlMethods = async () =>{
    return axios.get(host+'/api/own_customers/control_method',{headers:headersRequest})
}

export const getOrganizationsByUser = async (usuario:number) =>{
    const response = await axios.get(`${server.host}${server.puertoMsClientesCredito}/api/own_customers/organization`, { headers:headersRequest, params:{usuarioId:usuario} })
    return response.data
  }

  export const getFamilyPriceByEDS = async (companyId:number) =>{
    const response = await axios.get(`${server.host}${server.puertoMsClientesCredito}/api/own_customers/family_price`, { headers:headersRequest, params:{companyId} })
    return response
  }

  export const createFlota = async (body:any) =>{
    return axios.post(host+'/api/own_customers/fleets/create',body,{headers:headersRequest})
}

export const updateFlota = async (body:any) =>{
    return axios.put(host+'/api/own_customers/fleets/edit',body,{headers:headersRequest})
}

export const getFlotasByOrganization = async (organizacion_id:number) =>{
    return axios.get(host+'/api/own_customers/fleets/get', { headers:headersRequest, params:{organizacion_id} })
}

export const blockUnblockFlota = async (body:any) =>{
    return axios.put(host+'/api/own_customers/fleets/block-unblock',body,{headers:headersRequest})
}

export const gestionCupoFlota = async (body:any) =>{
    return axios.put(host+'/api/own_customers/fleets/change-quota',body,{headers:headersRequest})
}
export const recargaFlota = async (body:any) =>{
    return axios.put(host+'/api/own_customers/fleets/recharge-balance',body,{headers:headersRequest})
}
export const importFlotas = async (body:any) =>{
    return axios.post(host+'/api/own_customers/importers/fleets',body,{headers:headersRequest})
}